// PrimeReact Editor'dan önce değerlendirilmeli; bu satır en üstte kalmalı.
import './quillSetup';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Import Chart.js manually to prevent chunk loading errors
// This ensures Chart.js is loaded synchronously instead of lazy loading
import 'chart.js/auto';

// Import styles
import './styles/layout/layout.scss';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import './styles/demo/demo.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
